<template>
    <v-row class="main-row-fill-height">
        <!-- <v-col cols="3" class="py-0">
            <v-card max-height="100%" height="100%" color="grey lighten-3" style="overflow: auto;">
                <v-navigation-drawer width="100%" height="100%" style="padding-top: 70px;">
                    <v-toolbar absolute flat color="primary" width="100%" height="70px" dark>
                        <v-toolbar-title>Auswahl Oberfläche</v-toolbar-title>
                    </v-toolbar>
                    <v-list class="pt-0">
                        <v-list-item-group v-model="active" color="grey darken-4">
                            <v-list-item :style="active === index ? 'pointer-events: none' : ''"
                                v-for="(item, index) in getDoorSurfaceItems" :key="index">
                                <v-list-item-content>
                                    <div class="subtitle-1 d-flex align-center justify-space-between">
                                        {{ item.displayText }}
                                        <v-icon v-if="item.completed()" color="success" class="ml-4">mdi-check-circle
                                        </v-icon>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>

                    <div v-if="typeof staffelFarbeDocument !== 'undefined'"
                        class="d-flex pa-3 mt-4 mx-5 document-container ">
                        <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon>
                        <a class="black--text" target="_blank" :href="staffelFarbeDocument.resourceLocation"
                            download>RAL Farben</a>
                    </div>

                    <div v-if="typeof tuerOberflaecheDocument !== 'undefined'"
                        class="d-flex pa-3 mt-4 mx-5 document-container ">
                        <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon>
                        <a class="black--text" target="_blank" :href="tuerOberflaecheDocument.resourceLocation"
                            download>Dekormuster</a>
                    </div>

                    <div v-if="typeof tuerOberflaecheFurnierDocument !== 'undefined'"
                        class="d-flex pa-3 mt-4 mx-5 document-container ">
                        <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon>
                        <a class="black--text" target="_blank" :href="tuerOberflaecheFurnierDocument.resourceLocation"
                            download>Furniermuster</a>
                    </div>

                    <div v-if="typeof aufsteckhuelsenSFSGollDocument !== 'undefined'"
                        class="d-flex pa-3 mt-4 mx-5 document-container ">
                        <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon>
                        <a class="black--text" target="_blank" :href="aufsteckhuelsenSFSGollDocument.resourceLocation"
                            download>Aufsteckhülsen</a>
                    </div>

                    <div v-if="typeof bodenanschluesseDocument !== 'undefined'"
                        class="d-flex pa-3 mt-4 mx-5 document-container">
                        <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon>
                        <a class="black--text" target="_blank" :href="bodenanschluesseDocument.resourceLocation"
                            download>Staffelzeichnungen</a>
                    </div>
                </v-navigation-drawer>
            </v-card>
        </v-col> -->
        <v-col cols="9" class="pa-0 pos-rel pad-b">
            <div class="top-bar pl-14 pr-10 py-8" ref="topBar">
                <div class="content">
                    <div class="text-section">
                        <h2 class="mb-2 menu-title">{{$t('turblattOberflache')}}</h2>
                        <p class="ma-0 menu-description">{{$t('turblattOberflacheDescription')}}</p>
                    </div>
                    <a href="javascript:void(0)" @click="toggleResources = !toggleResources" class="resources-holder"
                        v-if="showResources">
                        <div class="resources" :class="{ 'active': toggleResources }">
                            <div class="resources-placeholders">
                                <p class="menu-description">{{$t('resourcesLabel')}}</p>
                                <p class="font-weight-bold menu-title"><span>5</span> {{$t('documentsLabel')}}</p>
                            </div>
                            <div class="pl-5 dropdown-icon">
                                <v-icon class="icon-class">mdi-menu-down</v-icon>
                            </div>
                        </div>
                        <transition name="slide-fade">
                            <div class="resources-dropdown" v-if="toggleResources">
                                <div class="resources-placeholders">
                                    <p class="menu-description">{{$t('resourcesLabel')}}</p>
                                    <p class="font-weight-bold menu-title"><span>5</span> {{$t('documentsLabel')}}</p>
                                </div>
                                <div class="resources-content">
                                    <div v-if="(typeof staffelFarbeDocument !== 'undefined')"
                                        class="d-flex pa-3 mb-4 document-container ">
                                        <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon>
                                        <a class="black--text" target="_blank"
                                            :href="staffelFarbeDocument.resourceLocation" download>RAL Farben</a>
                                    </div>

                                    <div v-if="(typeof tuerOberflaecheDocument !== 'undefined')"
                                        class="d-flex pa-3 mb-4 document-container ">
                                        <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon>
                                        <a class="black--text" target="_blank"
                                            :href="tuerOberflaecheDocument.resourceLocation" download>Dekormuster</a>
                                    </div>

                                    <div v-if="(typeof tuerOberflaecheFurnierDocument !== 'undefined')"
                                        class="d-flex pa-3 mb-4 document-container ">
                                        <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon>
                                        <a class="black--text" target="_blank"
                                            :href="tuerOberflaecheFurnierDocument.resourceLocation"
                                            download>Furniermuster</a>
                                    </div>

                                    <div v-if="(typeof aufsteckhuelsenSFSGollDocument !== 'undefined')"
                                        class="d-flex pa-3 mb-4 document-container ">
                                        <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon>
                                        <a class="black--text" target="_blank"
                                            :href="aufsteckhuelsenSFSGollDocument.resourceLocation"
                                            download>Aufsteckhülsen</a>
                                    </div>

                                    <div v-if="(typeof bodenanschluesseDocument !== 'undefined')"
                                        class="d-flex pa-3 mb-4 document-container">
                                        <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon>
                                        <a class="black--text" target="_blank"
                                            :href="bodenanschluesseDocument.resourceLocation"
                                            download>Staffelzeichnungen</a>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </a>
                </div>
            </div>
            <v-divider></v-divider>
            <v-card data-simplebar flat :style="{'height': `calc(100% - ${bodyCalcHeight}px)`, 'max-height' : '100%'}" class="pa-8 pl-12 pt-6">
                <simplebar style="overflow-x: hidden;" class="px-2">
                <template v-if="getSubNavActiveId.mainNavActiveId == 4 && getSubNavActiveId.subNavActiveId == 0">
                    <template v-if="dataLoaded">
                        <door-leaf></door-leaf>
                    </template>
                </template>
                <template v-if="getSubNavActiveId.mainNavActiveId == 4 && getSubNavActiveId.subNavActiveId == 1">
                    <template v-if="dataLoaded">
                        <frame-surface></frame-surface>
                    </template>
                </template>
                <template v-if="getSubNavActiveId.mainNavActiveId == 4 && getSubNavActiveId.subNavActiveId == 2">
                    <template v-if="dataLoaded">
                        <flor-connection> </flor-connection>
                    </template>
                </template>
                </simplebar>
            </v-card>
                <div class="bottom-bar pb-6 text-center">
                    <v-divider class="py-4"></v-divider>
                    <v-btn :disabled="nextSaveBtnDisabled" depressed color="green" dark @click="nextStep();">{{$t('nextStepLabel')}}</v-btn>
                </div>
        </v-col>
        <v-col cols="3" class="py-0">
            <v-card max-height="100%" height="100%" color="grey lighten-3" style="overflow: auto;">
                <v-navigation-drawer width="100%" height="100%" style="padding-top: 70px;" permanent>
                    <div class="d-flex flex-column justify-space-between" style="height: 100%;">
                        <ModelsFound />
                        <div class="pr-1">
                            <v-expansion-panels flat accordion>
                                <RModelSelection />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RFunctions />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RFrame />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RMeasures />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RDoorLeafSurface />
                            </v-expansion-panels>

                        </div>
                        <div class="d-flex flex-column pa-4 right-buttons-holder">
                            <v-row class="px-2">
                                <v-col cols="6" class="px-2" v-if="newConfiguration">
                                    <v-btn outlined color="primary" width="100%" depressed @click="$EventBus.$emit('cancelDialogConfirmation')">
                                        {{ $t('cancelConfiguration') }}
                                    </v-btn>
                                </v-col>
                                <v-col class="px-2" :class="!newConfiguration? 'col-12' : 'col-6'">
                                    <SaveCurrentConfiguration :disabled-save-btn="nextSaveBtnDisabled"/>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </v-navigation-drawer>
            </v-card>
        </v-col>
    </v-row>
    <!-- <div class="content-wrapper" id="door-leaf-surface">
        <div class="wrapper-mask show" v-if="showModal"></div>
        <div class="row no-gutters content-row" v-if="!showModal">
            <div class="col-3">
                <div class="column-wrap d-flex flex-column">
                    <h3 class="title nav-title">Auswahl Oberfläche</h3>
                    <div class="inner-wrap d-flex" data-simplebar>
                        <div class="nav flex-column nav-pills main-navigation text-left" id="v-pills-tab" role="tablist"
                            aria-orientation="vertical">

                            

                            <a v-bind:class="{ 'nav-link': true, 'active': active == 1 }" @click.prevent="settingsNavigation(1)">Turblatt</a>
                            <a v-bind:class="{ 'nav-link': true, 'active': active == 2 }" @click.prevent="settingsNavigation(2)">Zarge</a>
                            <a v-bind:class="{ 'nav-link': true, 'active': active == 3 }" @click.prevent="settingsNavigation(3)">Bodenanschluss</a>
                        
                        </div>
                        <div class="download-holder" v-if="typeof staffelFarbeDocument !== 'undefined'">
                            <a :href="staffelFarbeDocument.resourceLocation" class="download-btn" download target="_blank">RAL Farben</a>
                        </div>
                        <div class="download-holder" v-if="typeof tuerOberflaecheDocument !== 'undefined'">
                            <a :href="tuerOberflaecheDocument.resourceLocation" class="download-btn" download target="_blank">Dekormuster</a>
                        </div>
                        <div class="download-holder" v-if="typeof tuerOberflaecheFurnierDocument !== 'undefined'">
                            <a :href="tuerOberflaecheFurnierDocument.resourceLocation" class="download-btn" download target="_blank">Furniermuster</a>
                        </div>
                        <div class="download-holder" v-if="typeof aufsteckhuelsenSFSGollDocument !== 'undefined'">
                            <a :href="aufsteckhuelsenSFSGollDocument.resourceLocation" class="download-btn" download target="_blank">Aufsteckhülsen</a>
                        </div>
                        <div class="download-holder" v-if="typeof bodenanschluesseDocument !== 'undefined'">
                            <a :href="bodenanschluesseDocument.resourceLocation" class="download-btn" download target="_blank">Staffelzeichnungen</a>
                        </div>
                    </div>
                    <div class="image-container left-image">
                        <div class="text-center">
                            
                            <img src="" alt="">
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-6 purple-background-after">
                <div class="column-wrap middle-col  d-flex flex-column">
                    <div class="inner-wrap d-flex" data-simplebar id="innerWrapper">
                        <div class="scroll-wrap">
                             <div v-bind:class="{'inputs-group': true, 'active': showSettingsContent == 1}">
                                 <template v-if="dataLoaded">
                                    <door-leaf></door-leaf>
                                 </template>
                            </div>   
                            <div v-bind:class="{'inputs-group': true, 'active': showSettingsContent == 2}">
                                <template v-if="dataLoaded">
                                    <frame-surface> </frame-surface>
                                </template>
                            </div>
                            <div v-bind:class="{'inputs-group': true, 'active': showSettingsContent == 3}">
                                 <template v-if="dataLoaded">
                                    <flor-connection> </flor-connection>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-3">
                <div class="column-wrap side-col d-flex flex-column justify-content-end">
                    <div class="side-wrap d-flex flex-column">
                        <div class="info-wrap">
                            
                            <ModelsFound />
                            <div class="inner-wrap d-flex right-part-inner-wrap" data-simplebar>
                                <RModelSelection></RModelSelection>
                                
                                <div class="accordion" id="accordionExample">
                                    <div class="card">
                                        <div class="card-header" id="headingOne34">
                                            <h5 class="mb-0">
                                                <button class="btn btn-link collapsed" type="button" data-toggle="collapse"
                                                    data-target="#collapseOne34" aria-expanded="true" aria-controls="collapseOne34">
                                                    Funktionsauswahl
                                                </button>
                                            </h5>
                                        </div>

                                        <div id="collapseOne34" class="collapse" aria-labelledby="headingOne34" data-parent="#accordionExample">
                                            <RFunctions></RFunctions>
                                            
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header" id="headingTwo34">
                                            <h5 class="mb-0">
                                                <button class="btn btn-link collapsed" type="button" data-toggle="collapse"
                                                    data-target="#collapseTwo34" aria-expanded="false" aria-controls="collapseTwo34">
                                                    Zargenauswahl
                                                </button>
                                            </h5>
                                        </div>
                                        <div id="collapseTwo34" class="collapse" aria-labelledby="headingTwo34" data-parent="#accordionExample">
                                            <RFrame></RFrame>
                                            
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header" id="headingThree34">
                                            <h5 class="mb-0">
                                                <button class="btn btn-link collapsed" type="button" data-toggle="collapse"
                                                    data-target="#collapseThree34" aria-expanded="false" aria-controls="collapseThree34">
                                                    Maßlatt
                                                </button>
                                            </h5>
                                        </div>
                                        <div id="collapseThree34" class="collapse" aria-labelledby="headingThree34" data-parent="#accordionExample">
                                            <RMeasures></RMeasures>
                                            
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header" id="headingFour3">
                                            <h5 class="mb-0">
                                                <button class="btn btn-link collapsed" type="button" data-toggle="collapse"
                                                    data-target="#collapseFour3" aria-expanded="false" aria-controls="collapseFour3">
                                                Türblatt Oberfläche
                                                </button>
                                            </h5>
                                        </div>
                                        <div id="collapseFour3" class="collapse" aria-labelledby="headingFour3" data-parent="#accordionExample">
                                            <RDoorLeafSurface></RDoorLeafSurface>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                           <v-app>
                                <div class="d-flex flex-column pa-4">
                                    <v-btn depressed color="green" dark @click="nextStep();">Weiter</v-btn>
                                    
                                    <v-row class="px-2">
                                        <v-col cols="6" class="px-2">
                                            <v-btn width="100%" depressed @click="$EventBus.$emit('cancelDialogConfirmation')">Cancel</v-btn> 
                                        </v-col>
                                        <v-col cols="6" class="px-2">
                                            <SaveCurrentConfiguration />   
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-app>
                        </div>
                    </div>                    
                </div>
            </div>
            
        </div>
        <div class="row no-gutters modal-row show" v-if="showModal">
            <div class="col-12">
                <div class="zoom-modal d-flex">
                    <a @click.prevent="toggleModal(false)" class="close-btn">
                        <img src="./../../assets/images/close.svg" alt="">
                    </a>
                    <img src="./../../assets/images/sample.svg" alt="" class="align-middle">
                </div>
            </div>
        </div> 
    </div> -->
</template>
<script>
    import * as $ from 'jquery';
    import Vue from 'vue';
    import {
        Characteristic,
        ValueDefinition,
        MapCharacteristicAndValue,
        DependenciesFilter
    } from '../../configurator/types';
    import {
        mapActions
    } from 'vuex';
    import {
        mapGetters
    } from 'vuex';
    import ModelsFound from './components/ModelsFound';
    import {
        DoorConfiguration
    } from '../../configurator/DoorConfiguration';
    import {
        MainNavigationFilter
    } from '../../configurator/MainNavigation';
    import SaveCurrentConfiguration from './components/SaveCurrentConfiguration';
    import nProgress from 'nprogress';
    import resourcesService from '../../services/Configurator/ResourcesService';


    import RModelSelection from './components/RModelSelection.vue';
    import RFunctions from './components/RFunctions.vue';
    import RFrame from './components/RFrame.vue';
    import RMeasures from './components/RMeasures.vue';
    import RDoorLeafSurface from './components/RDoorLeafSurface.vue';

    import DoorLeaf from './doorSurface/DoorLeaf.vue';
    import FrameSurface from './doorSurface/FrameSurface';
    import FlorConnection from './doorSurface/FloorConnection.vue';
    import simplebar from 'simplebar-vue';
    import 'simplebar/dist/simplebar.min.css';


    export default Vue.extend({
        name: 'DoorLeafSurface',
        components: {
            simplebar,
            RModelSelection,
            RFunctions,
            RFrame,
            RMeasures,
            RDoorLeafSurface,
            ModelsFound,
            SaveCurrentConfiguration,
            'door-leaf': DoorLeaf,
            'frame-surface': FrameSurface,
            'flor-connection': FlorConnection,

        },
        data() {
            return {
                showResources: true,
                toggleResources: false,
                showModal: false,
                showSettingsContent: 1,
                active: 0,
                windowMainNavId: 5,
                mauerwerkSelectedItem: 'Select An Option',
                mauerwerkOptions: [{
                        value: 'Option 1'
                    },
                    {
                        value: 'Option 2'
                    },
                ],
                settignsItems: [],
                dataLoaded: false,

                staffelFarbeDocument: {},
                tuerOberflaecheDocument: {},
                tuerOberflaecheFurnierDocument: {},
                aufsteckhuelsenSFSGollDocument: {},
                bodenanschluesseDocument: {},
                bodyCalcHeight: 0,
                nextSaveBtnDisabled: false
            }
        },
        computed: {
            ...mapGetters('configuratorModule', ['getSubNavActiveId', 'getCurrentDoorConfiguration', 'getRegisteredCharacteristicsValue',
                'getMainNav',
                'getDoorSurfaceItems'
            ]),
            ...mapGetters('doorLeafSurfaceModule', [ 'getCharacteristicAndValues']),
            newConfiguration: function(){
                if(this.$store.state.configuratorModule.productId == 0){
                    return true
                }
                else{
                    return false
                }
            },
            selectedZargenOberflache() {
                var selectedChar = this.getCurrentDoorConfiguration.Get(DoorConfiguration.DoorLeafSurface)
                    .filter((x) => x.code === 'KTU_MM_ABSCHLUSSPROFIL_O')[0];
                if (typeof selectedChar !== 'undefined')
                    return selectedChar;
                else
                    return {
                        description: 'Select an Option',
                        value: {
                            id: 999,
                            description: 'Select an Option',
                            value: '',
                            resource: '',
                        }
                    };
            },
            handleFlutterpl(){
                return this.getRegisteredCharacteristicsValue('KTU_MM_FUTTERPL_OBERFL', DoorConfiguration.DoorLeafSurface).value.value;
            }
        },
        watch: {
            handleFlutterpl(){
                this.setFutterplOberfl();
            }
        },
        methods: {
            ...mapActions('configuratorModule', ['updateDoorConfiguration', 'setMainNavigationItems',
                'setMainNavActiveId', 'incrementMainNavActiveId'
            ]),
            ...mapActions('doorLeafSurfaceModule', ['addCharacterisitc', 'valueAddCharacteristic',
                'calculateDoorLeafSurfaceDekorOpeningSide',
                'calculateDoorLeafSurfaceDekorCounterOpeningSide',
                'setSchlagleisteDependantCharacteristicOpeningSide',
                'setSchlagleisteDependantCharacteristicCounterOpeningSide',
                'calculateDoorLeafSurfaceZargeBS',
                'calculateDoorLeafSurfaceZargeGBS',
                'setSchlagleisteSpecialOpeningSide', 'setSchlagleisteSpecialCounterOpeningSide','setAProfilAndAWinkel','setNormalDichtungCharacteristic',
                'setAProfileSOAndWinkelSO', 'setFutterplOberfl', 'setStaffelOberfalche'
            ]),

            toggleModal(state) {
                this.showModal = state;
            },

            settingsNavigation(index) {
                this.active = index;
                this.showSettingsContent = index;
            },
            getCharacteristics() {
                const _this = this;

                NProgress.start();
                this.nextSaveBtnDisabled = true
                this.axios.get('api/doorleafsurface/')
                    .then(async response => {
                        await _this.$store.dispatch('doorLeafSurfaceModule/setDoorLeafSurfaceCharacteristics',
                            response.data);
                        await _this.$store.dispatch(
                            'doorLeafSurfaceModule/setSingleCharacteristicsFilteredOrDefaults', response
                            .data);
                        await _this.filterDoorLeafSurfaceDepencies();
                        _this.calculateCharacteristics();

                        _this.setAProfilAndAWinkel();
                        _this.setNormalDichtungCharacteristic();

                        _this.setSchlagleisteDependantCharacteristicOpeningSide();
                        _this.setSchlagleisteDependantCharacteristicCounterOpeningSide();
                        _this.setSchlagleisteSpecialOpeningSide();
                        _this.setSchlagleisteSpecialCounterOpeningSide();
                        _this.setStaffel();
                        _this.initializeDoorSurfaceChars();
                        _this.initializeDoorSurfaceCharsGBS();
                        _this.calculateDoorLeafSurfaceZargeBS();
                        _this.calculateDoorLeafSurfaceZargeGBS();
                        _this.setAProfileSOAndWinkelSO();
                        _this.setFutterplOberfl();
                        if(this.isStantardStaffel())
                            _this.setStaffelOberfalche()
                        _this.dataLoaded = true;
                    })
                    .finally(() => {
                        NProgress.done();
                        this.nextSaveBtnDisabled = false
                    });
            },
            resetModelSelection() {

                this.doorConfiguration = this.getCurrentDoorConfiguration;

                this.doorConfiguration.ClearConfiguration(DoorConfiguration.DoorLeafSurface);

                this.$store.dispatch('configuratorModule/updateDoorConfiguration', this.doorConfiguration);

                // this.updateNavigation();
                let mainNav = new MainNavigationFilter(this.getMainNav);
                let mainNavItems = mainNav.ResetMainNavigationItemStatus(this.windowMainNavId, false);
                this.setMainNavigationItems(mainNavItems);
            },
            async filterDependencies(characteristicCode) {
                return new Promise(async(resolve, reject) => {
                    await this.$store.dispatch('doorLeafSurfaceModule/setCharacteristicDependencies', characteristicCode).then(() => {
                        resolve();
                    })
                })
            },
            async filterDoorLeafSurfaceDepencies() {
                // await this.filterDependencies("CUST_MM_ZARGE_ART");
                await this.filterDependencies("KTU_MM_STAFFEL_OBERFLAECHE").then(async () => {
                    await this.filterDependencies('KTU_MM_STAFFEL');
                });
                await this.filterDependencies("CUST_MM_STAFFEL_FORM_OBF");
                await this.filterDependencies("CUST_MM_OBERFLACHE_TXT");

                await this.filterDependencies('KTU_MM_TOBERFL_BS');
                await this.filterDependencies('KTU_MM_TOBERFL_GBS');
                await this.filterDependencies('KTU_MM_TUERBAND');
                await this.filterDependencies('KTU_MM_AUFSTECKHUELSEN');
                await this.filterDependencies('KTU_MM_Z_DICHTUNG');
                await this.filterDependencies('KTU_MM_FALZ_BS');
                await this.filterDependencies('KTU_MM_FUTTERPLATTE_S');
                await this.filterDependencies('KTU_MM_FUTTERPLATTE_W');
                await this.filterDependencies('KTU_MM_D2_METALL_O');
                await this.filterDependencies('KTU_MM_FURNIEROBERFL_BS');
                await this.filterDependencies('KTU_MM_FURNIEROBERFL_GBS');
                await this.filterDependencies('KTU_MM_GLANZGRAD_BS');
                await this.filterDependencies('KTU_MM_GLANZGRAD_GBS');
                await this.filterDependencies('KTU_MM_FUTTERPL_OBERFL');
                await this.filterDependencies('KTU_MM_STAFFEL_FARBE');
            },

            setStaffel() {
                let staffelFormValue = this.getRegisteredCharacteristicsValue('CUST_MM_STAFFEL_FORM', DoorConfiguration.Measure).value.value;
                let staffelValues = this.getCharacteristicAndValues('KTU_MM_STAFFEL').values;
                if(staffelFormValue === 'STD') {
                    let valueToSet = staffelValues.find(x => x.value === 'LLT100102');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_STAFFEL'), valueDefinition: valueToSet });
                }
                else if(staffelFormValue === 'VS') {
                    let kurzFormValue = this.getRegisteredCharacteristicsValue('KTU_MM_ZARGEN_KURZFORM', DoorConfiguration.Frame).value.value;
                    if(kurzFormValue === 'US' ||
                        kurzFormValue === 'USB' ||
                        kurzFormValue === 'ES' ||
                        kurzFormValue === 'ES-SST' ||
                        kurzFormValue === 'ES-SV1' ||
                        kurzFormValue === 'ES-SV2'
                    ) {
                        let valueToSet = staffelValues.find(x => x.value === 'LLT100105');
                        this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_STAFFEL'), valueDefinition: valueToSet });
                    }
                    else if(kurzFormValue === 'UB' ||
                        kurzFormValue === 'UBS' ||
                        kurzFormValue === 'EB' ||
                        kurzFormValue === 'EB-SST' ||
                        kurzFormValue === 'EB-SV1' ||
                        kurzFormValue === 'EB-SV2'
                    ) {
                        let valueToSet = staffelValues.find(x => x.value === 'LLT100106');
                        this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_STAFFEL'), valueDefinition: valueToSet });
                    }
                }
                else if(staffelFormValue === 'HS') {
                    let staffelFormValue = this.getRegisteredCharacteristicsValue('CUST_MM_STAFFEL_FORM_OBF', DoorConfiguration.DoorLeafSurface).value.value;
                    if(staffelFormValue === 'BUCHE') {
                        let valueToSet = staffelValues.find(x => x.value === 'LLT100104');
                        this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_STAFFEL'), valueDefinition: valueToSet });
                    }
                    else if(staffelFormValue === 'EICHE') {
                        let valueToSet = staffelValues.find(x => x.value === 'LLT100103');
                        this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_STAFFEL'), valueDefinition: valueToSet });
                    }
                    else {
                        this.filterDependencies("CUST_MM_STAFFEL_FORM_OBF");
                        let staffelValuesTwo = this.getCharacteristicAndValues('CUST_MM_STAFFEL_FORM_OBF').values;
                        let valueToSetTwo = staffelValuesTwo.find(x => x.value === 'BUCHE');
                        this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('CUST_MM_STAFFEL_FORM_OBF'), valueDefinition: valueToSetTwo });
                        let valueToSet = staffelValues.find(x => x.value === 'LLT100104');
                        this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_STAFFEL'), valueDefinition: valueToSet });
                    }
                }
                else {
                    this.filterDependencies("CUST_MM_STAFFEL_FORM_OBF");
                    let staffelValuesTwo = this.getCharacteristicAndValues('CUST_MM_STAFFEL_FORM_OBF').values;
                    let valueToSetTwo = staffelValuesTwo.find(x => x.value === 'NEIN');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('CUST_MM_STAFFEL_FORM_OBF'), valueDefinition: valueToSetTwo });
                    let valueToSet = staffelValues.find(x => x.value === 'NEIN');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_STAFFEL'), valueDefinition: valueToSet });
                }
            },

            calculateCharacteristics() {
                // this.calculateDoorLeafSurfaceDekorOpeningSide({chacrateristicCode : "KTU_MM_TUEROBERFL_BS"});
                // this.calculateDoorLeafSurfaceDekorCounterOpeningSide({chacrateristicCode : "KTU_MM_TUEROBERFL_GBS"});

                this.calculateDoorLeafSurfaceDekorOpeningSide({
                    chacrateristicCode: "KTU_MM_TUEROBERFL_BS"
                });
                this.calculateDoorLeafSurfaceDekorCounterOpeningSide({
                    chacrateristicCode: "KTU_MM_TUEROBERFL_GBS"
                });
            },
            getDocuments: function () {

                this.staffelFarbeDocumentResources();
                this.tuerOberflaecheDocumentResources();
                this.tuerOberflaecheFurnierDocumentResources();
                this.aufsteckhuelsenSFSGollDocumentResources();
                this.bodenanschluesseDocumentResources();
            },
            staffelFarbeDocumentResources: function () {
                const _this = this;
                var resource = resourcesService.getResourcesByCharacteristicCode('KTU_MM_STAFFEL_FARBE');

                resource.then(function (result) {
                    _this.staffelFarbeDocument = result.data[0];
                })
            },
            tuerOberflaecheDocumentResources: function () {
                const _this = this;
                var resource = resourcesService.getResourcesByCharacteristicCode('KTU_MM_TOBERFL_BS');

                resource.then(function (result) {
                    _this.tuerOberflaecheDocument = result.data[0];
                })
            },
            tuerOberflaecheFurnierDocumentResources: function () {
                const _this = this;
                var resource = resourcesService.getResourcesByCharacteristicCode('KTU_MM_TUEROBERFL_F_BS');

                resource.then(function (result) {
                    _this.tuerOberflaecheFurnierDocument = result.data[0];
                })
            },
            aufsteckhuelsenSFSGollDocumentResources: function () {
                const _this = this;
                var resource = resourcesService.getResourcesByCharacteristicCode('KTU_MM_AUFSTECKHUELSEN');

                resource.then(function (result) {
                    _this.aufsteckhuelsenSFSGollDocument = result.data[0];
                })
            },
            bodenanschluesseDocumentResources: function () {
                const _this = this;
                var resource = resourcesService.getResourcesByCharacteristicCode('KTU_MM_STAFFEL');

                resource.then(function (result) {
                    _this.bodenanschluesseDocument = result.data[0];
                })
            },
            nextStep() {
                let nextStep;
                let doorMainFunction = this.getCurrentDoorConfiguration.GetCurrentDoorMainFunction();

                // if(doorMainFunction.value.value === 'IT') {
                //     nextStep = this.windowMainNavId + 2;
                //     let mainNav2 = new MainNavigationFilter(this.getMainNav);
                //     let mainNavItems2 = mainNav2.ResetMainNavigationItemStatus(this.windowMainNavId, true);
                //     this.setMainNavigationItems(mainNavItems2);
                // } else {
                //     nextStep = this.windowMainNavId + 1;
                // }

                nextStep = this.windowMainNavId + 1;

                let mainNav = new MainNavigationFilter(this.getMainNav);

                let mainNavItems = mainNav.UpdateMainNavigation(this.getDoorSurfaceItems, nextStep);
                // this.$store.dispatch('setMainNavigationItems', mainNavItems);
                this.setMainNavigationItems(mainNavItems);

                const nextMainNavItem = mainNavItems.filter(x => x.itemId == nextStep)[0];
                if (nextMainNavItem.disabled == false) {
                    /*  this.setMainNavActiveId(nextStep); */
					const activeMainNavIndex = this.getMainNav.findIndex(f => f.itemId === this.windowMainNavId)
					this.incrementMainNavActiveId(activeMainNavIndex);
					this.$EventBus.$emit('triggerMaxHeight')
                    this.$router.push('/product-configurator' + nextMainNavItem.route);
                } else {
                    console.log('DoorLeaf Surface step not completed!');
                }
            },
            isMassivholzstaffel() {
                let staffelFormValue = this.getRegisteredCharacteristicsValue('CUST_MM_STAFFEL_FORM', DoorConfiguration.Measure).value.value;
                return staffelFormValue === "HS";
            },
            isStantardStaffel: function() {
                let staffelFormValue = this.getRegisteredCharacteristicsValue('CUST_MM_STAFFEL_FORM', DoorConfiguration.Measure).value.value;
                return staffelFormValue === "STD";
            },
            initializeDoorSurfaceChars() {
                let getToberflBs = this.getRegisteredCharacteristicsValue("KTU_MM_TOBERFL_BS", DoorConfiguration.DoorLeafSurface).value.value;
                let selectFurnierValues = this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_F_BS').values;
                let selectLackierungValues = this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_L_BS').values;
                let selectDekorValues = this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_BS').values;
                if(getToberflBs === 'DEKOR'){
                    let valueToSetFurnier = selectFurnierValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_F_BS'), valueDefinition: valueToSetFurnier });
                    let valueToSetLackierung = selectLackierungValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_L_BS'), valueDefinition: valueToSetLackierung });
                }
                else if (getToberflBs === 'FURNIER') {
                    let valueToSetDekor = selectDekorValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_BS'), valueDefinition: valueToSetDekor });
                    let valueToSetLackierung = selectLackierungValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_L_BS'), valueDefinition: valueToSetLackierung });
                }
                else if (getToberflBs === 'LACKIERUNG') {
                    let valueToSetFurnier = selectFurnierValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_F_BS'), valueDefinition: valueToSetFurnier });
                    let valueToSetDekor = selectDekorValues.find(x => x.value === 'LLT120077');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_BS'), valueDefinition: valueToSetDekor });
                }
            },
            initializeDoorSurfaceCharsGBS() {
                let getToberflBs = this.getRegisteredCharacteristicsValue("KTU_MM_TOBERFL_GBS", DoorConfiguration.DoorLeafSurface).value.value;
                let selectFurnierValues = this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_F_GBS').values;
                let selectLackierungValues = this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_L_GBS').values;
                let selectDekorValues = this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_GBS').values;
                if(getToberflBs === 'DEKOR'){
                    let valueToSetFurnier = selectFurnierValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_F_GBS'), valueDefinition: valueToSetFurnier });
                    let valueToSetLackierung = selectLackierungValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_L_GBS'), valueDefinition: valueToSetLackierung });
                }
                else if (getToberflBs === 'FURNIER') {
                    let valueToSetDekor = selectDekorValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_GBS'), valueDefinition: valueToSetDekor });
                    let valueToSetLackierung = selectLackierungValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_L_GBS'), valueDefinition: valueToSetLackierung });
                }
                else if (getToberflBs === 'LACKIERUNG') {
                    let valueToSetFurnier = selectFurnierValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_F_GBS'), valueDefinition: valueToSetFurnier });
                    let valueToSetDekor = selectDekorValues.find(x => x.value === 'LLT120077');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_GBS'), valueDefinition: valueToSetDekor });
                }
            },
            recalcBodyHeight(){
                //calculation of top-bar height 
                if(this.$refs.topBar.clientHeight != this.bodyCalcHeight)
                    this.bodyCalcHeight = this.$refs.topBar.clientHeight;
            }
        },
        created() {
            window.addEventListener("resize", this.recalcBodyHeight);
        },
        destroyed() {
            window.removeEventListener("resize", this.recalcBodyHeight);
        },
        mounted() {
            console.log("mounted doorleaf");
            this.getCharacteristics();
            this.getDocuments();

            //calculation of top-bar height 
            this.bodyCalcHeight = this.$refs.topBar.clientHeight;
        }
    });
</script>
<style lang="scss" scoped>
    .main-row-fill-height {
        height: 100%;
        margin-left: 0;
        margin-right: 0;

        >.col {
            max-height: 100%;
        }
    }

    .text-container,
    .document-container {
        background: #efefef;
    }
</style>